import { alpha, styled } from '@mui/material/styles';
import { Column } from 'global/components/row';
import { Button } from 'global/components/Button';

export const StyledContainer = styled('div')(({ theme }) => ({
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  clear: 'both',
  width: '100%',

  [theme.breakpoints.down('md')]: {
    padding: 0,
  },

  pageBreakInside: 'avoid !important',
}));

export const StyledChkImg = styled('div', {
  shouldForwardProp: (prop) => prop !== 'above',
})(({ theme, above }) => ({
  // PFM-2685: COMPLEX (graded/rating) checklists display the single checklist-level
  // image — and its EDIT MEDIA upload control — stacked ABOVE the rating grid,
  // centered at ~50% width with no float (`above`). SIMPLE checklists keep the
  // existing right-side 50% float so their layout is unchanged.
  width: '50%',

  '& img': {
    width: '100%',
  },

  ...(above
    ? {
        float: 'none',
        margin: '0 auto',
        marginBottom: theme.spacing(2),
        [theme.breakpoints.down('md')]: {
          width: '100%',
        },
        '@media print': {
          float: 'none',
          margin: '0 auto',
        },
      }
    : {
        float: 'right',
        [theme.breakpoints.down('md')]: {
          width: '100%',
          float: 'none',
        },
        '@media print': {
          float: 'right',
        },
      }),
}));

export const StyledContentContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'noImage',
})(({ theme, noImage }) => ({
  padding: theme.spacing(1),

  [theme.breakpoints.down('md')]: {
    width: `calc(100% - ${theme.spacing(4)})`,
  },

  ...(noImage
    ? {
        width: '75%',
        margin: 'auto',
        '@media print': {
          width: '75%',
        },
      }
    : {}),
}));

export const StyledRow = styled('div', {
  shouldForwardProp: (prop) => !['centerVertically', 'hlRow', 'imageRowSpacing'].includes(prop),
})(({ theme, centerVertically, hlRow, imageRowSpacing }) => ({
  display: 'flex',
  flexDirection: 'row',
  position: 'relative',
  ...(centerVertically ? { alignItems: 'center' } : {}),
  ...(hlRow ? { backgroundColor: alpha(theme.palette.error.main, 0.15) } : {}),
  ...(imageRowSpacing
    ? {
        marginTop: theme.spacing(1),
        marginLeft: theme.spacing(4),
      }
    : {}),
}));

export const StyledBuffer = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(1.5),
  pageBreakInside: 'avoid !important',
}));

export const StyledCapitalizeStrong = styled('strong', {
  shouldForwardProp: (prop) => prop !== 'longTitle',
})(({ longTitle }) => ({
  ...(longTitle ? {} : { textTransform: 'capitalize' }),
}));

export const StyledIconContainer = styled('div')(({ theme }) => ({
  color: theme.palette.grey[500],
  marginRight: theme.spacing(1),
}));

export const StyledRowText = styled('div')({
  fontSize: 14,

  '@media print': {
    fontSize: 12,
  },
});

export const StyledAdditionalText = styled('div')(({ theme }) => ({
  fontWeight: 'bold',
  fontSize: 25,
  marginBottom: theme.spacing(2),
}));

export const StyledSubText = styled('div')(({ theme }) => ({
  fontSize: 17,
  marginTop: theme.spacing(1),
}));

export const StyledChecklistName = styled('div')(({ theme }) => ({
  fontWeight: 'bold',
  fontSize: 20,
  marginBottom: theme.spacing(2),
}));

export const StyledEditButton = styled(Button)(({ theme }) => ({
  marginRight: theme.spacing(1),
  '@media print': {
    display: 'none',
  },
}));

export const StyledForm = styled('div', {
  shouldForwardProp: (prop) => prop !== 'formLoading',
})(({ theme, formLoading }) => ({
  margin: theme.spacing(1),
  ...(formLoading ? { pointerEvents: 'none', opacity: 0.5 } : {}),
}));

export const StyledEditButtonRow = styled(Column, {
  shouldForwardProp: (prop) => prop !== 'dangerBg',
})(({ theme, dangerBg }) => ({
  padding: theme.spacing(2),
  marginTop: `-${theme.spacing(2)}`,
  ...(dangerBg ? { backgroundColor: alpha(theme.palette.error.main, 0.15) } : {}),
}));
